import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

const SPEED = 0.1

export const iconCarousel = () => {

	const els = document.querySelectorAll('[data-animation="icon-carousel"]')

	if (!els.length) return false

	els.forEach(el => {

		let tracks = el.querySelectorAll('[data-direction]')

		tracks.forEach(track => {
			gsap.fromTo(track, {
				x: 0,
			}, {
				x: (track.dataset.direction == 'forward' ? -track.offsetWidth + window.innerWidth : track.offsetWidth - window.innerWidth) * SPEED,
				ease: 'none',
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					end: 'bottom top',
					scrub: true,
					// markers: true,
				}
			})
		})
	})
}

export default () => { }